
import { tripEventsMapping } from '@util/tripMapper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TripsMarker from '@components/trip-detail/maplib/TripsMarker.vue';
import IconMarkerEvent from '@components/icons/icon-marker-event.svg';
import IconEventAccelerate from '@components/icons/icon-event-accelerate.svg';
import IconEventBrake from '@components/icons/icon-event-brake.svg';
import IconEventLeft from '@components/icons/icon-event-left.svg';
import IconEventRight from '@components/icons/icon-event-right.svg';
import IconEventOverspeed from '@components/icons/icon-event-overspeed.svg';

@Component({
  name: 'TripsEventMarker',
  components: {
    TripsMarker,
    IconMarkerEvent,
    IconEventAccelerate,
    IconEventBrake,
    IconEventLeft,
    IconEventRight,
    IconEventOverspeed,
  }
})
export default class TripsEventMarker extends Vue {
  @Prop ({ required: true })
  private coordinates;

  @Prop ({ required: true })
  private type: string;

  get mappedCoordinates() {
    return { lat: this.coordinates.latitude, lng: this.coordinates.longitude };
  }

  get eventTypeMapping() {
    return tripEventsMapping.find(mapping => mapping.type === this.type);
  }
}
